import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface InvoiceListPeriodEndHeaderProps
  extends HeaderContext<InvoiceModel, InvoiceModel['periodEnd']> {}

export const InvoiceListPeriodEndHeader =
  (): // props: InvoiceListPeriodEndHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-invoice.period-end');
  };
